import axios from "axios";

export default {
    getProducts() {
        return axios.get(`/products`);
    },
    postProduct(obj) {
        return axios.post(`/products`,obj);
    },
    postProductMedia(id,obj) {
        return axios.post(`/products/${id}/media`,
            obj,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    },
    putProduct(id, obj) {
        return axios.put(`/products/${id}`, obj);
    },
    deleteProduct(id) {
        return axios.delete(`/products/${id}`);
    },
    getProductCat(iri){
        return axios.get(`${iri}/products`)
    },
};
